module.exports = __webpack_public_path__ + "img/soccerboard74.f5c0aed2.jpg";